function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Caret Right"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-width": 18,
  "data-height": 32,
  className: "iconic-container",
  transform: " translate(7 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.6 15.7l-19.2-15.4c-.2-.2-.4-.1-.4.2v31c0 .3.2.4.4.2l19.2-15.4c.2-.2.2-.4 0-.6z",
  className: "iconic-property-fill",
  transform: "rotate(0 16 16 )"
}));

function SvgCaretRightMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-icon": "caret-right",
    width: 32,
    height: 32,
    className: "iconic iconic-caret iconic-size-md iconic-caret-right",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRightMd);
export default __webpack_public_path__ + "static/media/caret-right-md.1088f3f1.svg";
export { ForwardRef as ReactComponent };